import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Tooltip, IconButton, Stack, Paper, Divider, Box } from "@mui/material";
import "./portefeuilClientV2.scss";
import { AccountBalance, AccountBoxSharp, AccountTree, Business, Cancel, Delete, Domain, East as EastIcon, PaymentTwoTone, Person, QuestionAnswer, Refresh, Settings, West as WestIcon, Search as SearchIcon } from "@mui/icons-material";
import { COLORS, output, priceFormatterV3 } from "../../settings/themeSettings";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "../../settings/toastSetting";
import { useEffect, useState } from "react";
import { editClient, fetchClients } from "../../data/slices/clientStore";
import { Search, SearchIconWrapper, StyledInputBase } from "../BFacturation/BFacturation";
import PersonaeDialog from '../../components/dialogs/PersonaeDialog';
import ParametresDialog from '../../components/dialogs/ParametresDialog';
import Loader from "../../components/Loader/Loader";
const PortefeuilClient = ({ title, mode = "liste" }) => {

    const navigateTo = useNavigate();
    const { clients, fetchStatus } = useSelector((state) => state.clients);
    const { me } = useSelector((state) => state.me);
    const dispatch = useDispatch();
    const [confirmation, setConfirmation] = useState(false);
    const [selected, setSelected] = useState(null);
    const [page, setPage] = useState(1);
    const [nail, setNail] = useState(null);
    const [filterType, setFilterType] = useState('all'); // 'all', 'personne', 'structure'

    // Nouveaux states pour les dialogs
    const [personaeOpen, setPersonaeOpen] = useState(false);
    const [parametresOpen, setParametresOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    const handleClose = (confirmed = false) => {
        setConfirmation(false);

        if (confirmed) {
            // TODO: Vérifier s'il y a des transactions avant de supprimer
            // const hasTransactions = await checkClientTransactions(selected.id);
            // if (hasTransactions) {
            //     notify('Impossible de supprimer: des transactions existent pour ce client', 'error');
            //     return;
            // }

            editClient(selected.id, { ...selected, isarchived: true }, (err) => {
                output(err);

            }, (resp) => {
                output(resp);

                setSelected(null);
                dispatch(fetchClients());


            });
        } else {
            setSelected(null);
        }
    }



    const handleOpenParametres = (client) => {
        setSelectedClient(client);
        setParametresOpen(true);
    };

    const handleSaveParametres = (formData) => {
        console.log('Sauvegarde paramètres:', formData);
        
        // We ensure we merge formData into selectedClient 
        // to not lose other properties like 'structure', 'balance', etc.
        const updatedClient = {
            ...selectedClient,
            ...formData
        };

        editClient(selectedClient.id, updatedClient, (err) => {
            output(err);
            // Optionally add error notification here
        }, (resp) => {
            dispatch(fetchClients());
        });
    };

    useEffect(() => {
        window.onInterrogerClient = (clientId) => {
            setParametresOpen(false); // Close dialog
            navigateTo('/billeterie/factures/' + clientId);
        };
        return () => {
             delete window.onInterrogerClient;
        };
    }, [navigateTo]);



    const consulterFacture = (clientId) => {
        navigateTo('/billeterie/factures/' + clientId);
    }

    useEffect(() => {
        dispatch(fetchClients({ page, nail }));
    }, [page, nail, dispatch]);

    const filteredClients = clients.filter(client => {
        if (client.code === 'COMPTANT') return false;
        if (filterType === 'personne') return !client.structure;
        if (filterType === 'structure') return !!client.structure;
        return true;
    });

    const handleToggleSommeil = (client) => {
        const updatedClient = { ...client, miseEnSommeil: !client.miseEnSommeil };
        editClient(client.id, updatedClient, (err) => output(err), (resp) => {
            dispatch(fetchClients({ page, nail }));
        });
    };




    return <Box className="portefeuil-client-v2">
        <Box className="cyber-header">
            <Typography variant="h4" className="cyber-title">
                {title || "Portefeuille Client"}
            </Typography>
            {mode === "liste" && me?.profil?.includes('ADMIN') && (
                <Button
                    variant="contained"
                    className="cyber-button-primary"
                    startIcon={<AccountBoxSharp />}
                    onClick={() => navigateTo('/billeterie/portefeuil/ajout')}
                >
                    Nouveau Client
                </Button>
            )}
        </Box>

        <Box className="search-section-cyber">
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center" width="100%">

                <Search className="cyber-search-container">
                    <SearchIconWrapper>
                        <SearchIcon sx={{ color: COLORS.primary }} />
                    </SearchIconWrapper>
                    <StyledInputBase
                        className="cyber-input"
                        placeholder="Rechercher un client instantanément..."
                        inputProps={{ 'aria-label': 'search' }}
                        autoFocus
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            clearTimeout(window.searchTimeout);
                            window.searchTimeout = setTimeout(() => {
                                setNail(inputValue || undefined);
                                setPage(1);
                            }, 150); // Plus rapide pour une sensation de temps réel
                        }}
                    />
                </Search>

                <IconButton className="cyber-refresh-btn" onClick={() => dispatch(fetchClients())}>
                    <Refresh sx={{ color: COLORS.primary }} />
                </IconButton>
            </Stack>
        </Box>

        <Box className="filter-tabs-cyber">
            <Button 
                className={`filter-tab ${filterType === 'all' ? 'active' : ''}`} 
                onClick={() => setFilterType('all')}
                startIcon={<AccountTree fontSize="small" />}
            >
                Tous les clients
            </Button>
            <Button 
                className={`filter-tab ${filterType === 'personne' ? 'active' : ''}`} 
                onClick={() => setFilterType('personne')}
                startIcon={<Person fontSize="small" />}
            >
                Personnes Physiques
            </Button>
            <Button 
                className={`filter-tab ${filterType === 'structure' ? 'active' : ''}`} 
                onClick={() => setFilterType('structure')}
                startIcon={<Domain fontSize="small" />}
            >
                Structures (Morales)
            </Button>
        </Box>

        {fetchStatus === 'loading' ? (
            <Box className="loader-box">
                <Loader text="Chargement des clients..." />
            </Box>
        ) : (
            <Box className="content-area-cyber">
                <Box className="client-grid-cyber">
                    {filteredClients.map((client, idx) => (
                        <Paper key={client.id || idx} className={`client-card-cyber ${client.miseEnSommeil ? 'sommeil' : ''}`} elevation={0}>
                            <Box className="card-top">
                                <Avatar
                                    className="client-avatar-cyber clickable"
                                    sx={{ bgcolor: client.miseEnSommeil ? COLORS.gray[400] : COLORS.secondary }}
                                    src={client.logo}
                                    onClick={() => handleOpenParametres(client)}
                                >
                                    {client.structure ? <Business /> : <AccountBoxSharp />}
                                </Avatar>
                                <Box className="client-main-info clickable" onClick={() => handleOpenParametres(client)}>
                                    <Typography className="client-name-cyber">
                                        {client.structure ? client.nom : `${client.prenom} ${client.nom}`}
                                    </Typography>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <AccountBalance sx={{ fontSize: '1rem', color: COLORS.primary }} />
                                        <Typography className="client-balance-cyber">
                                            {priceFormatterV3(client.balance || 0)}
                                        </Typography>
                                    </Stack>
                                </Box>
                                <Box className="factures-badge">
                                    <Typography variant="caption">{client.factures?.length || 0} FAC</Typography>
                                </Box>
                                {client.miseEnSommeil && (
                                    <Box className="sommeil-badge">
                                        <Typography variant="caption">SOMMEIL</Typography>
                                    </Box>
                                )}
                            </Box>

                            <Divider sx={{ my: 1.5, borderColor: 'rgba(255,255,255,0.05)' }} />

                            <Box className="card-actions-cyber">
                                {mode === "liste" ? (
                                    <>
                                        <Tooltip title="Interroger (Compte/Relevé)">
                                            <IconButton size="small" onClick={() => consulterFacture(client.id)} className="action-btn-cyber status">
                                                <QuestionAnswer fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Paramètres">
                                            <IconButton size="small" onClick={() => handleOpenParametres(client)} className="action-btn-cyber settings">
                                                <Settings fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Factures">
                                            <IconButton size="small" onClick={() => consulterFacture(client.id)} className="action-btn-cyber factures">
                                                <PaymentTwoTone fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={client.miseEnSommeil ? "Sortir de sommeil" : "Mettre en sommeil"}>
                                            <IconButton size="small" onClick={() => handleToggleSommeil(client)} className={`action-btn-cyber cancel ${client.miseEnSommeil ? 'active' : ''}`}>
                                                <Cancel fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        {me?.profil?.includes('ADMIN') && (
                                            <Tooltip title="Supprimer">
                                                <IconButton size="small" onClick={() => { 
                                                    // Vérification des transactions ou mouvements avant d'autoriser la suppression/archivage
                                                    const hasTransactions = (client.factures && client.factures.length > 0) || (client.balance && client.balance !== 0);
                                                    if (hasTransactions) {
                                                        notify("Impossible de supprimer/archiver ce client : des mouvements ou transactions ont déjà été enregistrés pour ce compte.", "error");
                                                        return;
                                                    }
                                                    setConfirmation(true); 
                                                    setSelected(client); 
                                                }} className="action-btn-cyber delete">
                                                    <Delete fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <Tooltip title="Consulter le relevé / Factures">
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => consulterFacture(client.id)}
                                                startIcon={<PaymentTwoTone />}
                                                className="cyber-button-releve"
                                                sx={{
                                                    borderColor: COLORS.primary,
                                                    color: COLORS.primary,
                                                    '&:hover': {
                                                        borderColor: COLORS.secondary,
                                                        bgcolor: 'rgba(255,255,255,0.05)'
                                                    }
                                                }}
                                            >
                                                Voir Relevé
                                            </Button>
                                        </Tooltip>
                                    </>
                                )}
                            </Box>
                        </Paper>
                    ))}
                </Box>

                <Box className="pagination-cyber">
                    <Button
                        disabled={page <= 1}
                        onClick={() => setPage(page - 1)}
                        startIcon={<WestIcon />}
                        className="pagination-btn-cyber"
                    >
                        Précédent
                    </Button>
                    <Typography className="page-indicator">Page {page}</Typography>
                    <Button
                        disabled={clients.length < 10 || fetchStatus === 'last_item'}
                        onClick={() => setPage(page + 1)}
                        endIcon={<EastIcon />}
                        className="pagination-btn-cyber"
                    >
                        Suivant
                    </Button>
                </Box>
            </Box>
        )}



        <Dialog
            open={confirmation}
            onClose={handleClose}
        >
            <DialogTitle style={{ cursor: 'move' }} >
                Confirmation de suppression
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Êtes-vous sûr de vouloir supprimer ce client ? 
                    (Il ne sera plus visible dans la liste active).
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    color="secondary"
                    onClick={() => handleClose(false)}>
                    Annuler
                </Button>
                <Button
                    color="secondary"
                    onClick={() => handleClose(true)}>Supprimer</Button>
            </DialogActions>
        </Dialog>

        {/* Dialog PERSONAE */}
        <PersonaeDialog
            open={personaeOpen}
            onClose={() => setPersonaeOpen(false)}
            client={selectedClient}
        />

        {/* Dialog PARAMETRES */}
        <ParametresDialog
            open={parametresOpen}
            onClose={() => setParametresOpen(false)}
            client={selectedClient}
            onSave={handleSaveParametres}
        />

    </Box>


}


export default PortefeuilClient;
